import { jsx } from 'react/jsx-runtime';
import { useState, useEffect, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { initializeI18n } from '../services/i18nService.js';

const I18nProvider = ({ shopBundle, locale, env, children, }) => {
    const [i18nInstance, setI18nInstance] = useState();
    useEffect(() => {
        (async () => {
            const initializedI18n = await initializeI18n(shopBundle, locale, env);
            setI18nInstance(initializedI18n);
            initializedI18n.changeLanguage(locale);
        })();
    }, [shopBundle, locale, env]);
    if (!i18nInstance) {
        return null;
    }
    return (jsx(Suspense, { fallback: () => null, children: jsx(I18nextProvider, { i18n: i18nInstance, children: children }) }));
};

export { I18nProvider, I18nProvider as default };
//# sourceMappingURL=I18nProvider.js.map
